import { SummaryPlatform } from "./summaryAnalyticsTypes";

export const SUMMARY_PLATFORM_COLORS: Record<SummaryPlatform, string> = {
  facebook: "#1877F2",
  instagram: "#E1306C",
  tiktok: "#6B7280",
  linkedinBusiness: "#0A66C2",
};

export const SUMMARY_PLATFORM_LABEL_KEYS: Record<SummaryPlatform, string> = {
  facebook: "app.sidebar.metrics.Facebook",
  instagram: "app.sidebar.metrics.Instagram",
  tiktok: "app.sidebar.metrics.TikTok",
  linkedinBusiness: "app.sidebar.metrics.LinkedInBusiness",
};
